import React from 'react'
import {Badge, ImageBuffer, SubHeader} from '../../'
import { servicesData } from '../../../utils/constants'

import './services.css'

const Services = () => {
  return (
    <>
        <div id="services" className='services-wrapper'>
            <Badge title="Services" />
            <SubHeader title="Our Intervention Services" description="Our Intervention Services." />
            <div className="services-container">
            <div className="services-gradient-background"></div>
                <div className='services-container-grid-box'>
                    {servicesData.map((result, index) => {
                        return(
                            <div className="services-main-box" key={index}>
                                <div className="services-main-box-image">
                                    <ImageBuffer src={result.icon} alt={result.title} />
                                </div>
                                <div className="services-main-cover">
                                    <h3 className="services-main-title">{result.title}</h3>
                                    <p className="services-main-desc">{result.description}</p>
                                </div>
                            </div>
                        )  
                    })}
                </div>
            </div>
        </div>
    </>
  )
}

export default Services